import { createModelStore } from '@/shared/stores/create-model-store'
import { model3InitialModel } from './initial-state'
import { model3DimensionHandlers } from './dimensions'

export const useModel3Store = createModelStore({
  initialModel: model3InitialModel,
  dimensionHandlers: model3DimensionHandlers,
})
